import { config as requiredConfig } from './required/view';
import { config as phoneConfig } from './phone/view';
import { config as emailConfig } from './email/view';
import { config as numberConfig } from './number/view';
import { config as idCardConfig } from './id-card/view';
import { config as integerConfig } from './integer/view';
import { config as maxItemsConfig } from './max-items/view';
import { config as minItemsConfig } from './min-items/view';
import { config as zhConfig } from './zh/view';
import { config as patternConfig } from './pattern/view';
import { config as filterCustomConfig } from './filter-custom/view';
import { config as customConfig } from './custom/view';
import { config as dateInternalConfig } from './date-internal/view';
import { config as checkUploadIsCompleteConfig } from './check-upload-is-complete/view';
import { config as checkObjectValuesConfig } from './object-value/view';
export const componentMap = {
    required: requiredConfig,
    phone: phoneConfig,
    email: emailConfig,
    idcard: idCardConfig,
    integer: integerConfig,
    number: numberConfig,
    zh: zhConfig,
    pattern: patternConfig,
    maxItems: maxItemsConfig,
    minItems: minItemsConfig,
    custom: customConfig,
    filterCustom: filterCustomConfig,
    dateInterval: dateInternalConfig,
    checkUploadIsComplete: checkUploadIsCompleteConfig,
    checkObjectValues: checkObjectValuesConfig,
};
// 注册校验方法
export function registerValidator(plugin) {
    const { name } = plugin || {};
    if (name) {
        componentMap[name] = plugin;
    }
}
